// extracted by mini-css-extract-plugin
module.exports = {"icon-circle":"_1ix2aHLA42mBGbyZSPkhIb","icon-circle__icon":"uzGAxCruxIMfIjFYyAHkI","icon-circle--red":"_2vnUOOO8b6_wSbJwmLC3lf","icon-circle--blue":"_1iKpmhiugm0xlLFT42zP6c"};